import { Link } from 'element-tiptap'
import InsertFileButton from './InsertFile'

export default class Bold extends Link {
  // here you can extend the extension like tiptap, such as schema, plugins ...

  constructor(auth, currentSite, permissions, profile, folderCode = '') {
    super()
    this.auth = auth
    this.currentSite = currentSite
    this.permissions = permissions
    this.profile = profile
    this.folderCode = folderCode
  }

  menuBtnView(editorContext) {
    return {
      component: InsertFileButton,
      componentProps: {
        auth: this.auth,
        currentSite: this.currentSite,
        permissions: this.permissions,
        profile: this.profile,
        folderCode: this.folderCode
      },
      componentEvents: {
        insertFile: (item) => {
          editorContext.commands.link({ href: `/file/${item.item_code}`, openInNewTab: true })
        },
        insertImage: (item) => {
          editorContext.commands.image({ src: item.public_url })
        }
      }
    }
  }
}
